/* eslint-disable @nx/enforce-module-boundaries */
import { useEffect, useState, useContext } from 'react';
import {
  Card,
  Stack,
  Tabs,
  TabList,
  Tab,
  Heading,
  HStack,
  Spinner,
  Text,
} from '@mybridge/ui';
import { PublicProfileContext } from 'v4/components/public-profile/context';
import styles from './videos.module.scss';
import InfiniteScroll from 'react-infinite-scroll-component';
import _ from 'lodash';
import DashboardReelModal from 'v4/components/ReelModal/DashboardReelModal';
import ImageModal from 'v4/components/imageModal/ImageModal';
import { fancyTimeFormat } from 'v4/lib/commons';
import { useTranslator } from '@mybridge/ui/custom-hooks/useTranslation';

export const PublicProfileVideos = ({linkForVideos}) => {
  const {
    publicProfile,
    userProfileInfo,
    photosOfYouCount,
    hasPhotosOfYou,
    photosOfYou,
    refetchPhotosOfyou,
    photosOfYouHasNextPage,
    photosOfYouFetchNextPage,
    yourPhotos,
    yourPhotosCount,
    hasYourPhotos,
    refetchYourPhotos,
    yourPhotosHasNextPage,
    yourPhotosFetchNextPage,
    yourVideos,
    hasYourVideos,
    yourVideosCount,
    refetchyourVideos,
    yourVideosHasNextPage,
    yourVideosFetchNextPage,
    videosOfYou,
    hasVideosOfYou,
    videosOfYouCount,
    refetchvideosOfYou,
    videosOfYouHasNextPage,
    videosOfYouFetchNextPage,
  } = useContext(PublicProfileContext);

  const [activeTab, setActiveTab] = useState(0);
  const [activeVideoTab, setActiveVideoTab] = useState(0);
  const { t } = useTranslator();

  const [reelModel, setReelModel] = useState(false);
  const [reelModelProps, setReelModelProps] = useState({
    postsData: [],
    onClose: () => {},
    fetchNext: () => {},
    hasMore: true,
    postIndex: 0,
    postMediaIndex: 0,
  });

  const [imageModel, setImageModel] = useState(false);
  const [imageModelProps, setImageModelProps] = useState({
    postsData: [],
    onClose: () => {},
    fetchNext: () => {},
    hasMore: true,
    postIndex: 0,
    postMediaIndex: 0,
  });

  const [isInitialLoading, setIsInitialLoading] = useState(true);
  const [isVideosOfYouLoading, setIsVideosOfYouLoading] = useState(false);
  const [isYourVideosLoading, setIsYourVideosLoading] = useState(false);

  useEffect(() => {
    if (publicProfile) {
      setIsInitialLoading(true);
      // Fetch all necessary data when component mounts
      Promise.all([
        refetchPhotosOfyou?.({ slug: publicProfile.slug }),
        refetchYourPhotos?.({ user: publicProfile.slug }),
        refetchyourVideos?.({ user: publicProfile.slug }),
        refetchvideosOfYou?.({ user: publicProfile.slug })
      ]).then(() => {
        setIsInitialLoading(false);
      }).catch(err => {
        console.error("Error fetching video data:", err);
        setIsInitialLoading(false);
      });
    }
  }, [publicProfile]);

  useEffect(() => {
    if (activeVideoTab === 0) {
      setIsVideosOfYouLoading(true);
      refetchvideosOfYou?.({ user: publicProfile.slug })
        .then(() => setIsVideosOfYouLoading(false))
        .catch(() => setIsVideosOfYouLoading(false));
    } else if (activeVideoTab === 1) {
      setIsYourVideosLoading(true);
      refetchyourVideos?.({ user: publicProfile.slug })
        .then(() => setIsYourVideosLoading(false))
        .catch(() => setIsYourVideosLoading(false));
    }
  }, [activeVideoTab, publicProfile]);

  const PhotosTabsArray = [
    {
      title: `${t('publicProfile.photosOf') || "Photos of"} ${publicProfile.first_name}`,
    },
    {
      title: `${publicProfile.first_name}'s ${t('profilePhotosVideos.photos') || "Photos"}`,
    },
  ];
  const VideosTabsArray = [
    {
      title: `${t('publicProfile.videosOf') || "Videos of"} ${publicProfile.first_name}`,
    },
    {
      title: `${publicProfile.first_name}'s ${t('profilePhotosVideos.videos') || "Videos"}`,
    },
  ];

  if (isInitialLoading) {
    return (
      <Card variant="thinBorderedCard" mb={6} p={4}>
        <HStack justifyContent="center" py={4}>
          <Spinner />
        </HStack>
      </Card>
    );
  }

  return (
    <>
      <Card variant="thinBorderedCard" mb={6} p={4}>
        <div className={styles.headerCont2}>
          <div className={styles.heading1}>{t('profilePhotosVideos.videos') || "Videos"}</div>
          {/* <div className={styles.linkText}>
            <a href="#">See all</a>
          </div> */}
        </div>
        <Stack minH="300px">
          <Tabs index={activeVideoTab} mb={6}>
            <TabList borderBottomColor="transparent">
              {VideosTabsArray.map((t, index) => (
                <div key={index} onClick={() => setActiveVideoTab(index)}>
                  <Tab>{t?.title}</Tab>
                </div>
              ))}
            </TabList>
          </Tabs>
          {activeVideoTab === 0 && (
            isVideosOfYouLoading ? (
              <HStack justifyContent="center" py={4}>
                <Spinner />
              </HStack>
            ) : (
              <CustomInfiniteVideoScroll
                dataLength={videosOfYouCount}
                next={videosOfYouFetchNextPage}
                hasMore={videosOfYouHasNextPage}
                isVideos={hasVideosOfYou}
                videosArray={videosOfYou}
                setReelModel={setReelModel}
                setReelModelProps={setReelModelProps}
              />
            )
          )}
          {activeVideoTab === 1 && (
            isYourVideosLoading ? (
              <HStack justifyContent="center" py={4}>
                <Spinner />
              </HStack>
            ) : (
              <CustomInfiniteVideoScroll
                dataLength={yourVideosCount}
                next={yourVideosFetchNextPage}
                hasMore={yourVideosHasNextPage}
                isVideos={hasYourVideos}
                videosArray={yourVideos}
                setReelModel={setReelModel}
                setReelModelProps={setReelModelProps}
              />
            )
          )}
        </Stack>
      </Card>
      {reelModel && <DashboardReelModal {...reelModelProps} />}

      {/* <Card variant="thinBorderedCard" mb={6} p={4}>
        <Stack>
          <div className={styles.headerCont2}>
            <div className={styles.heading1}>{t('profilePhotosVideos.photos') || "Photos"}</div>
            <div className={styles.linkText}>
              {yourPhotos && yourPhotos.length > 0 && (
                <a href='#' onClick={linkForVideos}>{t('profilePhotosVideos.seeAll') || "See all"}</a>
              )}
            </div>
          </div>
        </Stack>
        <Stack minH="300px">
          <Tabs index={activeTab} mb="24px">
            <TabList borderBottomColor="transparent">
              {PhotosTabsArray.map((t, index) => (
                <div key={index} onClick={() => setActiveTab(index)}>
                  <Tab>{t?.title}</Tab>
                </div>
              ))}
            </TabList>
          </Tabs>
          {activeTab === 0 && (
            <CustomInfiniteScroll
              dataLength={photosOfYouCount}
              next={photosOfYouFetchNextPage}
              hasMore={photosOfYouHasNextPage}
              isPhotos={hasPhotosOfYou}
              photosArray={photosOfYou}
              setImageModel={setImageModel}
              setImageModelProps={setImageModelProps}
            />
          )}
          {activeTab === 1 && (
            <CustomInfiniteScroll
              dataLength={yourPhotosCount}
              next={yourPhotosFetchNextPage}
              hasMore={yourPhotosHasNextPage}
              isPhotos={hasYourPhotos}
              photosArray={yourPhotos}
              setImageModel={setImageModel}
              setImageModelProps={setImageModelProps}
            />
          )}
        </Stack>
      </Card> */}

      {imageModel && <ImageModal {...imageModelProps} />}
    </>
  );
};

const CustomInfiniteScroll = ({
  // dataLength,
  dataLength = 0,
  next,
  hasMore,
  isPhotos,
  photosArray,
  setImageModelProps,
  setImageModel
}) => {
  const { t } = useTranslator();
  return (
    <>
      <InfiniteScroll
        className={styles.imgCont2}
        dataLength={dataLength}
        next={hasMore && next}
        hasMore={!!hasMore}
        loader={
          <HStack p={4} justifyContent="center" w="100%">
            <Spinner />
          </HStack>
        }
        endMessage={
          <Text style={{ textAlign: 'center' }} py={3}>
            {isPhotos ? '' : t('profilePhotosVideos.noPhotos') || 'No photos to show'}
          </Text>
        }
      >
        {isPhotos &&
          photosArray.map((Img, i) =>
            Img?.media?.length > 1 ? (
              Img?.media?.map((MultiImg, multiIndex) => (
                <div className={styles.card2} key={multiIndex}>
                  <img
                    src={MultiImg?.file}
                    alt="post image"
                    className={styles.img2}
                    onClick={() => {
                      const props = {
                        onClose: () => setImageModel(false),
                        postsData: photosArray,
                        fetchNext: next,
                        hasMore: hasMore,
                        postIndex: i,
                        postMediaIndex: multiIndex,
                      };
                      setImageModelProps(props);
                      setImageModel(true);
                    }}
                  />
                </div>
              ))
            ) : (
              <div className={styles.card2}>
                <img
                  src={Img.media?.[0]?.file}
                  alt="post image"
                  className={styles.img2}
                  onClick={() => {
                    const props = {
                      onClose: () => setImageModel(false),
                      postsData: photosArray,
                      fetchNext: next,
                      hasMore: hasMore,
                      postIndex: i,
                      postMediaIndex: 0,
                    };
                    setImageModelProps(props);
                    setImageModel(true);
                  }}
                />
              </div>
            )
          )}
      </InfiniteScroll>
    </>
  );
};

const CustomInfiniteVideoScroll = ({
  // dataLength,
  dataLength = 0,
  next,
  hasMore,
  isVideos,
  videosArray,
  setReelModel,
  setReelModelProps,
}) => {
  const { t } = useTranslator();
  return (
    <>
      <InfiniteScroll
        className={styles.imgCont2}
        dataLength={dataLength}
        next={hasMore && next}
        hasMore={!!hasMore}
        loader={
          <HStack p={4} justifyContent="center" w="100%">
            <Spinner />
          </HStack>
        }
        endMessage={
          <Text style={{ textAlign: 'center' }} py={3}>
            {isVideos ? '' : t('profilePhotosVideos.noVideos') || 'No Videos to show'}
          </Text>
        }
      >
        {isVideos &&
          videosArray.map((vid, i) =>
            vid.media?.length > 1 ? (
              vid?.media?.map((MultiVid, multiIndex) => (
                <div className={styles.card2} key={multiIndex}>
                  <video
                    src={MultiVid?.file}
                    alt="post image"
                    className={styles.vid1}
                    onClick={() => {
                      const props = {
                        onClose: () => setReelModel(false),
                        postsData: videosArray,
                        fetchNext: next,
                        hasMore: hasMore,
                        postIndex: i,
                        postMediaIndex: multiIndex,
                      };
                      setReelModelProps(props);
                      setReelModel(true);
                    }}
                  />
                  <div className={styles.videoLengthCont}>
                    {MultiVid?.duration
                      ? fancyTimeFormat(MultiVid?.duration)
                      : ''}
                  </div>
                </div>
              ))
            ) : (
              <div className={styles.card2}>
                <video
                  src={vid.media?.[0]?.file}
                  alt="post image"
                  className={styles.vid1}
                  onClick={() => {
                    const props = {
                      onClose: () => setReelModel(false),
                      postsData: videosArray,
                      fetchNext: next,
                      hasMore: hasMore,
                      postIndex: i,
                      postMediaIndex: 0,
                    };
                    setReelModelProps(props);
                    setReelModel(true);
                  }}
                />
                <div className={styles.videoLengthCont}>
                  {vid.media?.[0]?.duration
                    ? fancyTimeFormat(vid.media?.[0]?.duration)
                    : ''}
                </div>
              </div>
            )
          )}
      </InfiniteScroll>
    </>
  );
};
